import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTeamcityComponent } from './simple-icons-teamcity.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTeamcityComponent ],
    exports:      [ SimpleIconsTeamcityComponent ],
    bootstrap:    []
})
export class SimpleIconsTeamcityModule {}
